// extracted by mini-css-extract-plugin
export default {"alert":"U272__","icon":"EJzlGl","button":"lMAX0K"};